export enum ParticleTypeEnum {
  Item = 0,
  Instruction = 1,
  AdditionalInstruction = 2,
  DeliverTo = 3,
  Brand = 4,
  CountryCode = 5,
  VersionRelease = 6
}
